import { render, staticRenderFns } from "./MailView.vue?vue&type=template&id=10e465bc&scoped=true&"
import script from "./MailView.vue?vue&type=script&lang=js&"
export * from "./MailView.vue?vue&type=script&lang=js&"
import style0 from "./MailView.vue?vue&type=style&index=0&id=10e465bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e465bc",
  null
  
)

export default component.exports